/**
 * 접근 권한과 사용자 유형을 정의한다.
 * @version 1.0.0
 * @created 2026-09-28
 */

// ─── Authority ────────────────────────────────────────────────────────────────

/** 접근 권한 타입. */
export type Authority = (typeof AUTHORITIES)[number]["key"];

/** 접근 권한 목록. */
// Array order determines menu order.
export const AUTHORITIES = [
  { key: "RESERVATION", label: "예약관리", short: "예약" },
  { key: "CUSTOMER", label: "고객관리", short: "고객" },
  { key: "FINANCE", label: "정산관리", short: "정산" },
  { key: "EMPLOYEE", label: "직원관리", short: "직원" },
  { key: "CONSOLE", label: "시스템관리", short: "시스템" },
  { key: "PROFILE", label: "프로필", short: "프로필" },
  { key: "DOCUMENT", label: "문서관리", short: "문서" },
] as const;


/** 권한별 표시 이름. */
export const AUTHORITY_LABEL = Object.fromEntries(AUTHORITIES.map((a) => [a.key, a.short])) as Record<string, string>;

// ─── User Type ────────────────────────────────────────────────────────────────

// /** 사용자 유형 타입. */
// export type UserType = (typeof USER_TYPES)[number]["key"];

// /** 사용자 유형 목록. */
// export const USER_TYPES = [
//   { key: "ADMIN", label: "시스템 관리자" },
//   { key: "MANAGER", label: "관리자" },
//   { key: "COUNTER", label: "카운터" },
//   { key: "USER", label: "사용자" },
//   { key: "", label: "사용자" },
// ] as const;

// /** 사용자 유형별 표시 이름. */
// export const USER_TYPE_LABEL = Object.fromEntries(USER_TYPES.map((u) => [u.key, u.label])) as Record<string, string>;
